module.exports = require("jingle-media-data-session-purecloud");